export const ACTION_LABELS: Record<string, string> = {
  "interaction.started": "Interaction started",
  "customer360.opened": "Customer 360 opened",
  "tab.viewed": "Tab viewed",
  "cpni.verification.passed": "CPNI verification passed",
  "cpni.verification.failed": "CPNI verification failed",
  "cpni.usage.denied": "Usage blocked pending verification",
  "cpni.usage.read": "Usage read",
  "cpni.contact.read": "Contact unmasked",
  "payment.link.sent": "Secure payment link sent",
  "payment.ivr.transferred": "Transferred to IVR payment",
  "credit.applied": "Credit applied",
  "credit.approvalRequested": "Credit sent for approval",
  "credit.approved": "Credit approved",
  "credit.denied": "Credit denied",
  "ticket.created": "Helix ticket created",
  "ticket.viewed": "Ticket opened",
  "diagnostics.run": "Diagnostics run",
  "device.action": "Device action",
  "offer.presented": "Offer presented",
  "consent.viewed": "Consent record opened",
  "notice.sent": "Status notice sent",
  "appointment.viewed": "Appointment opened",
  "appointment.offered": "Appointment options offered",
  "admin.userEdited": "Admin action",
  "role.contextSwitched": "Role context switched",
  "journal.opened": "Journal opened",
  "invoice.viewed": "Invoice PDF opened",
  "guidance.opened": "Guidance opened",
  "ticket.linked": "Ticket linked",
  "retention.started": "Retention flow",
  "order.started": "Order started",
  "line.action": "Line action",
  "approval.reviewed": "Approval reviewed",
};

export function toastCopy(action: string, detail: Record<string, string | number | boolean | null>): string {
  const label = ACTION_LABELS[action] ?? action;
  const summary = typeof detail.summary === "string" ? detail.summary : "";
  return summary ? `${label} — ${summary}` : label;
}
